import { useTranslation } from 'react-i18next';
import { UI_COLORS, colorHelpers } from '../../utils/colors';

/**
 * Badge shown next to a coil that has been used by an order (claimed at placement) —
 * the physical roll is open, so it is a "loose" coil. Single source of the label and
 * styling, shared by the ledger, picker and split-panel so they can never drift.
 *
 * Renders nothing unless `coil.is_loose_coil` is truthy, so call sites can drop it in
 * unconditionally: `<LooseCoilBadge coil={coil} />`.
 */
const LooseCoilBadge = ({ coil, className = '' }) => {
  const { t } = useTranslation();
  if (!coil?.is_loose_coil) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold shrink-0 ${className}`}
      style={{
        color: UI_COLORS.STATUS.WARNING,
        backgroundColor: colorHelpers.withOpacity(UI_COLORS.STATUS.WARNING, 0.12),
      }}
    >
      {t('coils.looseCoil.badge')}
    </span>
  );
};

export default LooseCoilBadge;
